import script from "./LoyaltyDonut.vue?vue&type=script&setup=true&lang=js"
export * from "./LoyaltyDonut.vue?vue&type=script&setup=true&lang=js"

import "./LoyaltyDonut.vue?vue&type=style&index=0&id=76f13986&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f13986"]])

export default __exports__